// extracted by mini-css-extract-plugin
module.exports = {"metadataContainer":"eventDetail_metadataContainer__9vH8_","inputOutputContainer":"eventDetail_inputOutputContainer__124MB"};